<template>
  <div id="svg-preview" class="svg-preview-container">
    <div v-html="svgData" />
  </div>
</template>

<style scoped>
.svg-preview-container {
  height: 100%;
  background-color: #f7f7f7;
  border: 1px solid #c7cacc;
}
.theme-dark .svg-preview-container {
  background-color: #575c5a;
  border: 1px solid #373c3a;
}
.svg-preview-container > div {
  height: 100%;
}
</style>

<script>
export default {
  name: 'SVGPreview',
  props: {
    svgData: String
  },
  mounted() {
  },
  watch: {
    svgData: {
      handler(newVal) {
        if(this.$props.svgData) {
          // SVG PanZoom
          // Disabled until better editor comes along
          this.$nextTick(() => {
            /*svgPanZoom('#svg-preview > svg', {
              zoomEnabled: true,
              controlIconsEnabled: true,
              fit: false,
              center: false,
              minZoom: 0.5,
              maxZoom: 10,
              contain: true
            })*/
          })
        }
      }
    }
  }

}
</script>